import { render, staticRenderFns } from "./loucengfenbu.vue?vue&type=template&id=64842c7d&scoped=true&"
import script from "./loucengfenbu.vue?vue&type=script&lang=js&"
export * from "./loucengfenbu.vue?vue&type=script&lang=js&"
import style0 from "./loucengfenbu.vue?vue&type=style&index=0&id=64842c7d&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64842c7d",
  null
  
)

export default component.exports